import { GET } from '../request'

export const getFormacion = id => GET('/api/profes/formacion/formacion', { id })
